import { Header, SectionTitle } from "../components";

function getTypographyClassName(
  size: string,
  fontWeight?: string,
  isUppercase?: boolean
): string {
  if (size === "large" && fontWeight === "bold")
    return "clx-typography-large-bold";
  if (size === "medium" && fontWeight === "bold")
    return "clx-typography-medium-bold";
  if (size === "medium" && isUppercase)
    return "clx-typography-medium-uppercase";
  return `clx-typography-${size}`;
}

export const Typography = ({
  title,
  size,
  fontWeight,
  isUppercase,
  style,
}: {
  title: string;
  size: string;
  fontWeight?: string;
  isUppercase?: boolean;
  style?: React.CSSProperties;
}) => (
  <div className="typography-row" style={style}>
    <div className={getTypographyClassName(size, fontWeight, isUppercase)}>
      {title}
    </div>
  </div>
);

const Preview = ({ isDark }: { isDark: boolean }) => {
  const bgColor = isDark ? "var(--clx-savvy-black)" : "var(--clx-savvy-white)";
  const textColor = isDark ? "var(--clx-savvy-white)" : "var(--clx-savvy-900)";
  const labelColor = isDark
    ? "var(--clx-savvy-300)"
    : "var(--clx-savvy-accent)";

  return (
    <section
      className="typography-preview"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="typography-preview-main">
        <SectionTitle
          color={labelColor}
          title={`Heading styles on ${isDark ? "dark" : "light"} background`}
        />
        <div className="typography-preview-headings">
          <Typography title="Heading 1 (80)" size="h1" />
          <Typography title="Heading 2 (60)" size="h2" />
          <Typography title="Heading 3 (40)" size="h3" />
          <Typography title="Heading 4 (30)" size="h4" />
          <Typography title="HEADING 5 (30)" size="h5" />
          <Typography title="HEADING 6 (30)" size="h6" />
        </div>

        <div className="typography-preview-body-block">
          <SectionTitle
            color={labelColor}
            title={`Body text styles on ${
              isDark ? "dark" : "light"
            } background`}
          />
        </div>
        <div className="typography-preview-body-list">
          <Typography title="Large text (25) - Regular" size="large" />
          <Typography
            title="Large text (25) - Bold"
            size="large"
            fontWeight="bold"
          />
          <Typography title="Medium text (20) - Regular" size="medium" />
          <Typography
            title="Medium text (20) - Bold"
            size="medium"
            fontWeight="bold"
          />
          <Typography title="CAPTION (20)" size="medium" isUppercase />
          <Typography title="Normal text (18)" size="normal" />
          <Typography title="Small text (16)" size="small" />
          <Typography title="Supersmall text (12)" size="xs" />
        </div>
      </div>

      <div className="typography-preview-side">
        <SectionTitle color={labelColor} title="Font Style" />
        <div className="typography-preview-font-sample clx-typography-h3">
          <div className="typography-preview-font-sample-normal">
            Helvetica / Arial (system font)
            <br />
            Regular/Semibold/Bold
          </div>
          <div className="typography-preview-font-sample-secondary">
            <Typography title="AaBbCcDdEeFfGgHhIiJjKkLlM" size="large" />
            <Typography
              title="mNnOoPpQqRrSsTtUuVvWw"
              size="large"
              fontWeight="semibold"
            />
            <Typography
              title="XxYyZz0123456789+-@()|/$€↑↗→↘↓↙←↖"
              size="large"
              fontWeight="bold"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export const TypographyStyleGuide = () => (
  <>
    <Header title="CLX Typography" />

    <div className="typography-guide-column">
      <Preview isDark={false} />
      <Preview isDark={true} />
    </div>
  </>
);
